import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: 'var(--onSurfaceMuted)',
    marginTop: 4,
  },
  errorText: {
    fontSize: 14,
    color: 'var(--errorText)',
    margin: 0,
  },
  teamList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  teamItem: {
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid var(--surfaceBorder)',
    borderRadius: 6,
  },
  teamName: {
    fontSize: 14,
    fontWeight: 500,
    color: 'var(--onSurface)',
    margin: 0,
  },
  teamMembers: {
    fontSize: 12,
    color: 'var(--onSurfaceMuted)',
    margin: 0,
  },
  escapeRow: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 4,
  },
});
